import React from "react";
//#region redux
//#endregion
//#region types
import { MoreActionMenuItemType } from "models/propTypes/menuPropTypes";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { AnnualAccountMoreActionProps } from "models/propTypes/annualAccountPropTypes";
//#endregion
//#region components
import { MoreActions, useCheckRelations } from "components/common";
import { useAnnualAccountService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";

const AnnualAccountMoreActions: React.FC<AnnualAccountMoreActionProps> = (props) => {
  //#region download
  const annualAccountService = useAnnualAccountService();
  const { getIsRevisor, getIsAuditorAssistant } = useCheckRelations();
  const isAuditorView = getIsRevisor() || getIsAuditorAssistant();

  const financialStatementType = isAuditorView
    ? WintSuperkollAPIModel.FinancialStatementType.AnnualReport
    : WintSuperkollAPIModel.FinancialStatementType.AnnualReportAndIncomeTaxReturn;

  const onDownloadClick = async () => {
    return annualAccountService.downloadPdf(props.annualAccountReport.financialYearId ?? "", financialStatementType);
  };

  const downloadAction: MoreActionMenuItemType = {
    description: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Download),
    icon: IconDefinitionConstants.WDownload,
    onClickHandler: onDownloadClick,
  };

  //#endregion

  const getMenuItems = (): MoreActionMenuItemType[] => {
    const actions: MoreActionMenuItemType[] = [];

    actions.push(downloadAction);

    return actions;
  };

  return <MoreActions menuItems={getMenuItems()} disableSuccessMessages={props.disableSuccessMessages} />;
};

export default AnnualAccountMoreActions;
